module.exports = __webpack_public_path__ + "img/pike.f6c1fdb6.svg";